import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import DialogModal from "../../../../../components/Dialog";
import {
  computePartialCosts,
  computeTotalCost,
} from "../../../../../componentCostUtils";
import { auditLogUseCase } from "../../../../../usecases/logs";
import { findObjectUseCase } from "../../../../../usecases/object";

class StockRequestFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    // Preserve raw_materials if present in the view
    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {
        include: [
          "raw_materials",
          "raw_materials.uom",
          "uom",

          "sourceLocation",
          "destinationLocation",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  generateRequestNumber(prefix = "ANGELSPIZZA") {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    const randomDigits = Math.floor(1000 + Math.random() * 9000);

    return `${prefix}-${mm}${dd}${yyyy}-${randomDigits}`;
  }

  generateTransferNumber() {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    return `TRANSFER-${mm}${dd}${yyyy}-${randomDigits}`;
  }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    const rawMaterials = computePartialCosts(
      this.view.state.object.raw_materials || []
    );
    this.change.raw_materials = rawMaterials;

    const now = new Date();
    const currentTimestamp = now.toISOString();
    this.change.requestDate = now.toISOString();
    this.change.requestNumber = this.generateRequestNumber();
    this.change.status = "Pending";
    this.change.requestedBy = { id: user.id };
    this.change.sourceLocation = { id: this.change.sourceLocation.id };
    this.change.destinationLocation = { id: user.storeAnalytic[0]?.id };
    this.change.items = this.change.raw_materials;
    this.change.storeId = { id: user.storeAnalytic[0]?.id };
    delete this.change.raw_materials;

    try {
      const result = await this.upsertUseCase.execute(collection, this.change);

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Created stock request ${this.change.requestNumber} with ${this.change.items.length} item(s)`,
        collection,
        objectId: result.id,
        payload: {
          request: this.change,
          response: result,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });

      const transfer = {
        transferNumber: this.generateTransferNumber(),
        linkedRequestId: result.id,
        transferDate: now.toISOString(),
        requestDate: this.change.requestDate,
        // approvedDate: null, // will be updated later
        transferredBy: { id: user.id },
        sourceLocation: this.change.sourceLocation,
        destinationLocation: this.change.destinationLocation,
        items: this.change.items,
        remarks: this.change.remarks || "",
        logsArray: [
          {
            status: "Pending",
            timestamp: currentTimestamp,
            updatedBy: {
              id: user.id,
              name: user.username || user.email,
            },
            remarks: "Transfer record created",
          },
        ],
        status: "Pending",
        storeId: { id: user.storeAnalytic[0]?.id },
      };

      const responseTransfer = await this.upsertUseCase.execute(
        "stock_transfers",
        transfer
      );

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Created stock transfer ${transfer.transferNumber} linked to request ${this.change.requestNumber}`,
        collection: "stock_transfers",
        objectId: responseTransfer.id,
        payload: {
          transfer,
          response: responseTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
      this.change = {};
      this.view.hideProgressDialog();
    } catch (error) {
      throw error;
    }
  }

  async saveReceive(index) {
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.view.state.object;

    console.log("object", object);

    const updatePayload = {
      id: object.id,
      status: "Pending Fully Received",
    };

    console.log("object", updatePayload);
    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `Pending Fully Received stock request ${object.requestNumber}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await findObjectUseCase().execute("stock_transfers", {
      where: { linkedRequestId: object.id },
    });
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // 📦 Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "Pending Fully Received",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: object?.remarks,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "Pending Fully Received",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // 📝 Optional: Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to Pending Fully Received`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    dialog.close();
  }

  async savePartial(index) {
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.view.state.object;

    console.log("object", object);

    const updatedItems = (object.items || []).map((item, index) => {
      const receivedQty = parseFloat(
        object.items?.[index]?.quantityReceivePartial || 0
      );

      const remaining =
        Number(
          object.items?.[index]?.remainingQty ||
            object.items?.[index]?.quantityApprove
        ) - receivedQty;

      return {
        ...item,
        quantityReceive: String(receivedQty),
        remainingQty: String(remaining),
      };
    });

    const updatePayload = {
      id: object.id,
      items: updatedItems,
      status: "Pending Partially Received",
    };

    console.log("object", updatePayload);
    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `Pending Partially Received stock request ${object.requestNumber}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await findObjectUseCase().execute("stock_transfers", {
      where: { linkedRequestId: object.id },
    });
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // 📦 Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "Pending Partially Received",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: object?.remarks,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "Pending Partially Received",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // 📝 Optional: Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to Pending Partially Received`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    dialog.close();
  }

  async saveReconcile() {
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    const now = new Date();
    const currentTimestamp = now.toISOString();

    const object = this.view.state.object;

    console.log("object", object);

    const updatePayload = {
      id: object.id,
      reconcileRemarks: object.reconcileRemarks,
      attachment: object.attachment,

      status: "For Reconciliation",
    };

    console.log("object", updatePayload);
    const result = await this.upsertUseCase.execute(collection, updatePayload);

    await auditLogUseCase().create({
      user: { id: user.id },
      logDate: currentTimestamp,
      message: `For Reconciliation stock request ${object.requestNumber}" (s)`,
      collection,
      objectId: object.id,
      payload: {
        request: object,
        response: updatePayload,
      },
      store: { id: user.storeAnalytic?.[0]?.id },
    });

    const findTransfer = await findObjectUseCase().execute("stock_transfers", {
      where: { linkedRequestId: object.id },
    });
    console.log("findtrans", findTransfer);

    const existingTransfer = findTransfer[0];

    if (existingTransfer) {
      // 📦 Update the status and append to logsArray
      const existingLogs = existingTransfer.logsArray || [];

      const newLog = {
        status: "For Reconciliation",
        timestamp: currentTimestamp,
        updatedBy: {
          id: user.id,
          name: user.username || user.email,
        },
        remarks: object?.remarks,
      };
      const updatedLogs = [...existingLogs, newLog];
      const updatedTransfer = {
        id: existingTransfer.id,
        status: "For Reconciliation",
        logsArray: updatedLogs,
      };

      console.log("Update", updatedTransfer);

      await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

      // 📝 Optional: Audit log for transfer update
      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Updated stock transfer ${existingTransfer.transferNumber} to For Reconciliation`,
        collection: "stock_transfers",
        objectId: existingTransfer.id,
        payload: {
          transfer: existingTransfer,
          update: updatedTransfer,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });
    }

    // this.getObjects();
    dialog.close();
  }

  async submit() {
    const params = this.view.getParams();
    try {
      this.view.submitting();
      dialog.close();

      switch (params.view) {
        case "receive":
          await this.saveReceive();
          break;
        case "partial":
          await this.savePartial();
          break;
        case "reconcile":
          await this.saveReconcile();
          break;
        default:
          await this.save();
          break;
      }

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default StockRequestFormPresenter;
